module.exports = __webpack_public_path__ + "1cd4e05634a182e86707c68008735d2c.png";


//////////////////
// WEBPACK FOOTER
// ./Res/img/hausplanner_logo_gold3.png
// module id = 1158
// module chunks = 1